// Global helper — post a message to the screen reader live region.
// Usage: window.adaAnnounce('3 items in cart');
window.adaAnnounce = function(message) {
  var region = document.getElementById('ada-live-region');
  if (!region) return;
  region.textContent = '';
  requestAnimationFrame(function() {
    region.textContent = message;
  });
};
